import React from "react";
import "./ChecklistTeacherAbschluss.scss";
import TeacherChecklistForm from "../TeacherChecklistForm";
export default function ChecklistTeacherAbschluss() { return <TeacherChecklistForm type="abschluss" />; }
